<template>
  <div id="app">
    <template v-if="from === 'pc'">
      <index/>
      <keep-alive include="Home">
        <router-view/>
      </keep-alive>
      <bottom/>
    </template>
    <template v-if="from === 'mobile'">
      <router-view/>
    </template>
  </div>
</template>

<script>
import index from "@/views/home/index";
import Bottom from "@/components/common/bottom/Bottom";

export default {
  name: "App",
  components:{
    index,
    Bottom
  },
  data () {
    return {
      from: undefined
    }
  },
  created() {
    if(this._isMobile()) {
      this.from = 'mobile'
      this.$router.replace('/mb_home')
      console.log('手机端')
    } else {
      this.from = 'pc'
      this.$router.replace('/home')
      console.log('pc端')
    }
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile () {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    }
  }
}
</script>

<style lang="less" scoped>
  html, body {
    position: relative;
    margin:0;
    padding:0;
    width: 100%;
    min-width:1200px;
  }
</style>
